import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

export interface LabelListElement {
    label?: string;
    fallbackLabel?: string;
    value?: string;
    customValueClass?: string;
}

export interface LabelListProps {
    list: LabelListElement[];
    containerClass?: string;
    labelProvider?: labelProviderInterface,
    isLabelProviderOn?: boolean,
    hideTooltip?: boolean,
}

export const UiaasSearchLabelList: FunctionalComponent<LabelListProps> = ({
  list,
  containerClass,
  labelProvider,
  isLabelProviderOn,
  hideTooltip = false,
}, [Prepend, Append,...children] = []) => {
    if(!labelProvider || (labelProvider && !isLabelProviderOn)) {
      labelProvider = (name, fallback) => {
          return name || fallback;
      };
    }

    const getValue = (element:LabelListElement):string => {
        if(typeof element.value == 'string'){
          const languagesList = element.value.split(', ');
          if(element.label === 'tab.label.language' && languagesList.length > 1){
            const language = document.querySelector('uiaas-search')?.language;
            if(language) {
              const defaultLanguage = new Intl.DisplayNames([language], {type: 'language'}).of(language);
              if (languagesList.includes(defaultLanguage)) {
                languagesList.splice(languagesList.findIndex(el => el == defaultLanguage), 1);
                languagesList.unshift(defaultLanguage);
              }
            }
            return <span>
              {languagesList[0]}
              {!hideTooltip && <se-tooltip color="alternative" position="bottom">
                <span slot="trigger" class='document-card-more-languages'>{'+'}{languagesList.length - 1}</span>
                {languagesList.slice(1).join(', ')}
              </se-tooltip>}
            </span>;
          } else {
            return element.value ? <span innerHTML={element.value.trim()}/> : '';
          }
        }else{
          '';
        }
    };


    const labelElement = (element: LabelListElement) => {
        const valueClass = `value ${element?.customValueClass ? 'default-style ' + element.customValueClass : ''}`;
        return element.label
          ? (<div class={'label-list_element'}>
            <span class={'label m-right'}>{labelProvider(element.label, element?.fallbackLabel) + ': '}</span>
            <span class={valueClass}>{getValue(element)}</span>
          </div>) :
          (<div class={'label-list_element'}>
            <span class={valueClass}>{getValue(element)}</span>
          </div>);
    };

    const isSomeLabels = (list.filter((element) => !!element.value).length > 0);

    if(!isSomeLabels) {
      return ('');
    }

    return (<div class={`label-list ${containerClass ? containerClass : ''}`}>
      {Prepend}
      {list.filter((element) => !!element.value).map((element) => {
          return [labelElement(element)];
      })}
      {Append}
    </div>);
};
